<template>
	<div class="modal-card" style="width:auto">
		<header class="modal-card-head">
			<p class="modal-card-title">Change Currency</p>
			<div class="modal-close-button" @click="$emit('close')"></div>
		</header>
		<div class="modal-card-body">
			<b-select v-model="selection" placeholder="Select a currency" expanded>
				<option v-for="option in currencies" :value="option.Id" :key="option.Id">{{option.Name}}</option>
			</b-select>
		</div>
		<footer class="modal-card-foot">
			<b-button class="is-primary" :loading="changing" :disabled="changing" @click="ChangeCurrency">Change</b-button>
			<b-button class="is-light" @click="$emit('close')">Close</b-button>
		</footer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				changing: false,
				selection: undefined,
				currencies: []
			}
		},
		props: {
			currencyId: {
				type: Number,
				default: undefined
			}
		},
		methods: {
			async GetCurrencies() {
				try {
					var response = await this.$http.get("/api/filter/currencies");
					this.currencies = response.data;
					return response;
				}
				catch (err) {
					console.error(err);
					return Promise.reject();
				}
			},
			async ChangeCurrency() {
				this.changing = true;
				try {
					const Id = this.selection;
					var resp = await this.$http.get("/api/currency/" + Id);
					var xrate = await this.$http.get("/api/currency/" + Id + "/rate");
					var ranges = await this.$http.get("/api/currency/" + Id + "/ranges");
					this.$emit('close', { currency: resp.data, rate: xrate.data, ranges: ranges.data });
				}
				catch (err) {
					this.changing = false;
					console.error(err);
					return Promise.reject();
				}
			}
		},
		mounted() {
			this.GetCurrencies().then(resp => {
				if (this.currencyId) {
					const i = this.currencies.map(x => x.Id).indexOf(this.currencyId);
					this.selection = this.currencies[i].Id;
				}
				this.loading = false;
			});
		}
	}
</script>
